import { motion } from "framer-motion";
import { useLang } from "../i18n";

const IMG =
  "https://images.unsplash.com/photo-1577819175009-4bec3ab382e9?q=80&w=1600&auto=format&fit=crop";

const EASE = [0.16, 1, 0.3, 1];

export default function ChiSiamo() {
  const { t } = useLang();

  return (
    <section id="chi-siamo" data-testid="chi-siamo-section" className="relative py-28 md:py-36">
      <div className="mx-auto grid max-w-7xl gap-16 px-5 md:px-8 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: EASE }}
            className="text-[12px] font-semibold uppercase tracking-[0.35em] text-primary"
          >
            {t.about.label}
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: 0.1, ease: EASE }}
            className="mt-5 font-serif text-4xl leading-[1.05] tracking-tight text-white md:text-5xl"
          >
            {t.about.title}
          </motion.h2>

          <motion.figure
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: 0.2, ease: EASE }}
            className="mt-12"
          >
            <div className="overflow-hidden rounded-2xl border border-white/10">
              <img
                src={IMG}
                alt="Children smiling in Madagascar"
                className="aspect-[4/5] w-full object-cover transition-transform duration-700 hover:scale-105"
              />
            </div>
            <figcaption className="mt-3 text-[12px] uppercase tracking-[0.2em] text-white/40">
              {t.about.imageCaption}
            </figcaption>
          </motion.figure>
        </div>

        <div className="flex flex-col justify-center gap-14 lg:col-span-7 lg:pl-10">
          {t.about.chapters.map((ch, i) => (
            <motion.div
              key={ch.n}
              data-testid={`about-chapter-${ch.n}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: EASE }}
              className="flex gap-8 border-b border-white/10 pb-14 last:border-0 last:pb-0"
            >
              <span className="font-serif text-5xl italic leading-none text-primary/80 md:text-6xl">
                {ch.n}
              </span>
              <div>
                <h3 className="font-serif text-3xl tracking-tight text-white md:text-4xl">
                  {ch.title}
                </h3>
                <p className="mt-4 max-w-lg text-base leading-relaxed text-white/70">{ch.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
